@if (!hideOutput) {
  <iframe [src]="pentahoUrl" frameborder="0" width="100%" height="750px;"></iframe>
}
